export enum RegexEnum {
  PHONE = '^\\D?(\\d{3})\\D?\\D?(\\d{3})\\D?(\\d{4})$',
  EMAIL = "(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)",
  NUMBER = '^\\d*(\\.)?\\d+$',
  DECIMAL = '^[1-9]\\d*(\\.\\d+)?$',
  NAME = '^[a-zA-Z0-9]+[ ][a-zA-Z0-9]+$'
}
